module.exports = __webpack_public_path__ + "img/slide3.cf116812.png";